import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

function ToEmailModal(props) {
  const { onCancel, onConfirm, toEmailAddress } = props;
  const [input, setInput] = useState({to_email_address: toEmailAddress});

  function handleInputChange(e){
    setInput({
      ...input,
      [e.currentTarget.name]: e.currentTarget.value
    });
  }

  function handleConfirm(){
    onConfirm(input);
  }

  return (
    <Modal.Dialog>
      <Modal.Header onHide={onCancel} closeButton>
        <Modal.Title>Destination Email Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Enter an email address that will receive a report about these stones.</p>
        <Form.Control
          onChange={handleInputChange}
          type="email"
          name="to_email_address"
          placeholder="Enter destination email"
          value={input['to_email_address']}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel} variant="secondary">Close</Button>
        <Button onClick={handleConfirm} variant="primary">Send</Button>
      </Modal.Footer>
    </Modal.Dialog>
  );
}

export default ToEmailModal;
